<p translate class="title">questionBoard.edit.uploadFile.uploadFiles</p>
<div class="flex">
    <div class="upload pointer" (click)="file.click()" (FilesEvent)="filesDroped($event)">
        <p translate>questionBoard.edit.uploadFile.upload</p>
        <img src="/assets/images/definitions/upload-file.svg" />
    </div>
    <input class="display-none" type="file" #file (change)="onFileChange(file)">

    <div *ngIf="questionForm.value.additionalText" class="flex">
        <p>{{questionForm.value.additionalText}}</p>
        <img src="/assets/images/question-menu/delete.svg" class="img pointer" (click)="remove()">
    </div>
</div>
<div class="error" *ngIf="!isRoleAdmin$()">
    <p translate>questionBoard.edit.uploadFile.noPermission</p>
</div>